var map = {
	"./PaellaCoreVideoFormats.js": 1897,
	"./es.upv.paella.audioVideoFormat.js": 4504,
	"./es.upv.paella.hlsLiveVideoFormat.js": 951,
	"./es.upv.paella.hlsVideoFormat.js": 9805,
	"./es.upv.paella.htmlVideoFormat.js": 1395,
	"./es.upv.paella.imageVideoFormat.js": 4273,
	"./es.upv.paella.mp4VideoFormat.js": 1175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6590;